import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import { withThemeAndSize } from "../../withThemeAndSize/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import '../../../assets/index58.css';const modalSwitch = "_modalSwitch_h5003_1";
const s = {
  modalSwitch
};
const Switch = withThemeAndSize(
  forwardRef(({ className, children, asChild, ...rest }, ref) => {
    const Comp = asChild ? Slot : "div";
    return /* @__PURE__ */ jsx(Comp, { ...rest, className: clsx(s.modalSwitch, className), ref, children });
  })
);
Switch.displayName = "Modal.Switch";
export {
  Switch
};
